export function ordinalSuffix(day: number): string {
	if (day >= 11 && day <= 13) return "th";
	switch (day % 10) {
		case 1:
			return "st";
		case 2:
			return "nd";
		case 3:
			return "rd";
		default:
			return "th";
	}
}

export function formatTime(time: string | null | undefined): string | null {
	if (!time) return null;
	const date = new Date(`1970-01-01T${time}`);
	return date.toLocaleTimeString("en-US", {
		hour: "numeric",
		minute: "2-digit",
		hour12: true,
	});
}

export function formatTimestamp(
	timestamp: string | null | undefined,
): string | null {
	if (!timestamp) return null;
	const date = new Date(timestamp);

	const month = date.toLocaleString("en-US", { month: "short" });
	const day = date.getDate();
	const year = date.getFullYear();
	const time = date.toLocaleTimeString("en-US", {
		hour: "numeric",
		minute: "2-digit",
		hour12: true,
	});

	return `${month} ${day}${ordinalSuffix(day)}, ${year} | ${time}`;
}

export function formatDate(
	date: string | null | undefined,
	includeYear = false,
): string | null {
	if (!date) return null;
	const d = new Date(date);
	const weekday = d.toLocaleString("en-US", { weekday: "short" });
	const month = d.toLocaleString("en-US", { month: "short" });
	const day = d.getDate();
	const year = d.getFullYear();
	return includeYear
		? `${month} ${day}${ordinalSuffix(day)}, ${year}`
		: `${weekday}, ${month} ${day}${ordinalSuffix(day)}`;
}

export function formatPhone(phone: string | null | undefined): string | null {
	if (!phone) return null;
	const digits = phone.replace(/\D/g, "").slice(-10);
	if (digits.length !== 10) return phone;
	return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
}

export function formatDateTimeRange(
	startDate: string | null | undefined,
	endDate: string | null | undefined,
	startTime: string | null | undefined,
	endTime: string | null | undefined,
	includeYear = false,
): string | null {
	if (!startDate || !startTime || !endTime) return null;
	const timePart = `${formatTime(startTime)} - ${formatTime(endTime)}`;
	if (!endDate || endDate === startDate) {
		return `${formatDate(startDate, includeYear)} | ${timePart}`;
	}
	const start = new Date(startDate);
	const end = new Date(endDate);
	const startMonth = start.toLocaleString("en-US", { month: "short" });
	const endMonth = end.toLocaleString("en-US", { month: "short" });
	const startDay = start.getDate();
	const endDay = end.getDate();
	const sameMonth =
		start.getMonth() === end.getMonth() &&
		start.getFullYear() === end.getFullYear();
	const startPart = `${startMonth} ${startDay}${ordinalSuffix(startDay)}`;
	const endPart = sameMonth
		? `${endDay}${ordinalSuffix(endDay)}`
		: `${endMonth} ${endDay}${ordinalSuffix(endDay)}`;
	return `${startPart} - ${endPart} | ${timePart}`;
}

export function formatPercent(
	value: number | null | undefined,
): string | null {
	if (value == null) return null;
	return `${Math.round(value * 100)}%`;
}
